import {
    WallGeometry,
    PerInstanceColorAppearance,
    Cartesian3,
    ColorGeometryInstanceAttribute,
    GeometryInstance,
    Primitive,
} from 'cesium';
import { getColor } from '../renderer';

export default class Wall extends Primitive {
    constructor(option) {
        const {
            data,
            style = { extrudedHeight: 1000, fill: { color: '#119FFB', opacity: 0.4 } },
            key,
            minHeight,
            maxHeight
        } = option;
        let wall = new WallGeometry({
            positions: Cartesian3.fromDegreesArray([...data[0], data[0][0]].flat(Infinity)),
            maximumHeights: [...data[0], data[0][0]]?.map(item => maxHeight || style.height),
            minimumHeights: [...data[0], data[0][0]]?.map(item => minHeight || 0),
        });
        const instance = new GeometryInstance({
            geometry: wall,
            attributes: {
                color: ColorGeometryInstanceAttribute.fromColor(getColor(style.fill)),
            },
        });

        const primitive = new Primitive({
            geometryInstances: [instance],
            appearance: new PerInstanceColorAppearance(),
        });

        super(primitive);
        // 图层标识
        this.key = key;

        this.data = data;
    }
}
